import { render } from "./HeadMain.vue?vue&type=template&id=2f08aea1&scoped=true"
import script from "./HeadMain.vue?vue&type=script&lang=js"
export * from "./HeadMain.vue?vue&type=script&lang=js"

import "./HeadMain.vue?vue&type=style&index=0&id=2f08aea1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f08aea1"]])

export default __exports__